import red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';
import purple from '@material-ui/core/colors/purple';
import orange from '@material-ui/core/colors/orange';
import yellow from '@material-ui/core/colors/yellow';
import pink from '@material-ui/core/colors/pink';
import lime from '@material-ui/core/colors/lime';
import lightGreen from '@material-ui/core/colors/lightGreen';

export const PIECE_COLOR = {
  snippet: purple['700'],
  option: orange['600'],
  criterion: blue['700']
};

export const THEME_COLOR = {
  starColor: yellow['600'],
  badgeColor: pink['A100'],
  reviewingTaskBackgroundColor: lime['200'],
  alertBackgroundColor: 'rgb(240, 68, 61)',
  optionChosenBackgroundColor: 'rgb(204, 234, 211)' //lightGreen['500']
};



// WEBPACK FOOTER //
// ../shared-components/src/shared/theme.js